export default __webpack_public_path__ + "images/9d0630866438c9f11ef205b57cc093d2.svg";